/* eslint-disable no-plusplus */
import { Reducer } from 'react'
import { ActionCreateErrorState } from './types'
import { MultiBuyContext } from './Context'

export const reducer: Reducer<MultiBuyContext, ActionCreateErrorState> = (
  state,
  action,
) => {
  switch (action.type) {
    case 'SET_ERROR': {
      return {
        ...state,
        ...action.payload,
      }
    }
    /* istanbul ignore next */
    default:
      return state
  }
}
